var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 3.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7999",
    "data-name": "Trazado 7999",
    d: "M22.981,4h-7c-6.6,0-9.9,0-11.95,2.05-1.476,1.476-1.89,3.6-2.005,7.137h34.91C36.82,9.65,36.407,7.526,34.93,6.05,32.88,4,29.58,4,22.981,4Z",
    transform: "translate(0.019)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8000",
    "data-name": "Trazado 8000",
    d: "M23,26.937H16c-6.6,0-9.9,0-11.95-2.05S2,19.537,2,12.937q0-1.16,0-2.187H37q0,1.029,0,2.187c0,6.6,0,9.9-2.05,11.95S29.6,26.937,23,26.937Zm3.578-13.562a16.234,16.234,0,0,1,2.017.076,2.823,2.823,0,0,1,2.642,2.642,16.235,16.235,0,0,1,.076,2.017v.156a16.235,16.235,0,0,1-.076,2.017A2.823,2.823,0,0,1,28.6,22.924,16.234,16.234,0,0,1,26.578,23h-.156a16.234,16.234,0,0,1-2.017-.076,2.823,2.823,0,0,1-2.642-2.642,16.234,16.234,0,0,1-.076-2.017v-.156a16.234,16.234,0,0,1,.076-2.017A2.823,2.823,0,0,1,24.4,13.451a16.234,16.234,0,0,1,2.017-.076ZM7.687,15.562A1.313,1.313,0,0,1,9,14.25h3.5a1.313,1.313,0,1,1,0,2.625H9A1.313,1.313,0,0,1,7.687,15.562Zm0,5.25A1.313,1.313,0,0,1,9,19.5h7a1.313,1.313,0,0,1,0,2.625H9A1.313,1.313,0,0,1,7.687,20.812Z",
    transform: "translate(0 5.062)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8001",
    "data-name": "Trazado 8001",
    d: "M14.878,13.878l0,0,.018-.008a1.228,1.228,0,0,1,.292-.065,15.117,15.117,0,0,1,1.745-.052,15.117,15.117,0,0,1,1.745.052,1.228,1.228,0,0,1,.292.065l.018.008,0,0,0,0a.17.17,0,0,1,.008.018,1.228,1.228,0,0,1,.065.292,15.117,15.117,0,0,1,.052,1.745,15.117,15.117,0,0,1-.052,1.745,1.228,1.228,0,0,1-.065.292.17.17,0,0,1-.008.018l0,0,0,0-.018.008a1.228,1.228,0,0,1-.292.065,15.117,15.117,0,0,1-1.745.052,15.117,15.117,0,0,1-1.745-.052,1.228,1.228,0,0,1-.292-.065L14.882,18l0,0,0,0a.17.17,0,0,1-.008-.018,1.228,1.228,0,0,1-.065-.292,15.117,15.117,0,0,1-.052-1.745,15.117,15.117,0,0,1,.052-1.745,1.228,1.228,0,0,1,.065-.292.17.17,0,0,1,.008-.018Z",
    transform: "translate(9.562 7.312)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.72d0e0460db5005cbad6726c4c53c3e0.svg";
export { ForwardRef as ReactComponent };